import { render, staticRenderFns } from "./backups.vue?vue&type=template&id=6dba8046&scoped=true"
import script from "./backups.vue?vue&type=script&lang=js"
export * from "./backups.vue?vue&type=script&lang=js"
import style0 from "./backups.vue?vue&type=style&index=0&id=6dba8046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba8046",
  null
  
)

export default component.exports